import { render, staticRenderFns } from "./Blog.vue?vue&type=template&id=80a78f02&"
import script from "./Blog.vue?vue&type=script&lang=js&"
export * from "./Blog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports